import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './Passengers.css';
import PhoneCodeSelect from '../request/phoneCodeSelect';
import moment from 'moment';

class PassengerEditor extends Component {
  setDirty = (index) => (evt) => {
    const name = evt.target.name;
    this.props.onPassengerListUpdate(this.props.passengers.setIn([index, 'dirty_' + name], true));
  };

  handleUserInput = (index) => (evt) => {
    const name = evt.target.name;
    const value = evt.target.value;
    this.props.onPassengerListUpdate(this.props.passengers.setIn([index, name], value).setIn([index, 'dirty_' + name], true));
  };

  handleUpdatePhoneCode = (index) => (value) => {
    this.props.onPassengerListUpdate(this.props.passengers.setIn([index, 'phoneCode'], value).setIn([index, 'dirty_phoneCode'], true));
  };
  setDirtyPhoneCode = (index) => () => {
    this.props.onPassengerListUpdate(this.props.passengers.setIn([index, 'dirty_phoneCode'], true));
  };

  render() {
    const { passengers, showErrors = false } = this.props;
    return (
      <div className='form passengers-list'>
        {passengers.map((p, i) => (
          <div className='row passenger-item' key={i}>
            <div className='col-sm-push-2 col-sm-4'>
              <div className='col-wrapper-va'>
                <div className='v-align'>
                  <h3>Traveller {i + 1} ({p.get('ageClassification')})</h3>
                </div>
              </div>
            </div>
            <div className='col-sm-push-2 col-sm-16'>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='title' value='Title: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <select
                    className='combobox'
                    id='title'
                    name='title'
                    value={p.get('title')}
                    onBlur={this.setDirty(i)}
                    onChange={this.handleUserInput(i)}
                  >
                    <option value='' disabled>
                      -- Title --
                    </option>
                    <option value='Mr'>Mr</option>
                    <option value='Mrs'>Mrs</option>
                    <option value='Ms'>Ms</option>
                    <option value='Sr'>Sr</option>
                    <option value='Dr'>Dr</option>
                    <option value='Prof'>Prof</option>
                    <option value='Sir'>Sir</option>
                    <option value='Adv'>Adv</option>
                    <option value='Rev'>Rev</option>
                    <option value='Hon'>Hon</option>
                    <option value='Hon, Dr'>Hon, Dr</option>
                  </select>
                  <ValidationMessage message='Select a title' condition={(showErrors || p.get('dirty_title')) && p.get('title') === ''} />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='firstname' value='Firstname: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <input
                    placeholder='Firstname'
                    id='firstname'
                    type='text'
                    name='firstname'
                    value={p.get('firstname')}
                    onBlur={this.setDirty(i)}
                    onChange={this.handleUserInput(i)}
                  />
                  <ValidationMessage message='Enter a firstname' condition={(showErrors || p.get('dirty_firstname')) && p.get('firstname') === ''} />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='middlename' value='Middlename: ' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <input
                    placeholder='Middlename'
                    id='middlename'
                    type='text'
                    name='middlename'
                    value={p.get('middlename')}
                    onChange={this.handleUserInput(i)}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='surname' value='Surname: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <input
                    placeholder='Surname'
                    id='surname'
                    type='text'
                    name='surname'
                    value={p.get('surname')}
                    onBlur={this.setDirty(i)}
                    onChange={this.handleUserInput(i)}
                  />
                  <ValidationMessage message='Enter a surname' condition={(showErrors || p.get('dirty_surname')) && p.get('surname') === ''} />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='dateOfBirth' value='Date of Birth: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <div className='col-xs-6 no-padding-left'>
                    <input
                      placeholder='Day'
                      id='day'
                      type='text'
                      name='day'
                      value={p.get('day')}
                      onBlur={this.setDirty(i)}
                      onChange={this.handleUserInput(i)}
                      pattern='[0]*[1-9]|[1-2][0-9]|3[0-1]'
                    />
                  </div>
                  <div className='col-xs-10'>
                    <select
                      className='combobox'
                      id='month'
                      name='month'
                      value={p.get('month')}
                      onBlur={this.setDirty(i)}
                      onChange={this.handleUserInput(i)}
                      required
                    >
                      <option value='' disabled>
                        -- Month --
                      </option>
                      <option value='01'>January</option>
                      <option value='02'>February</option>
                      <option value='03'>March</option>
                      <option value='04'>April</option>
                      <option value='05'>May</option>
                      <option value='06'>June</option>
                      <option value='07'>July</option>
                      <option value='08'>August</option>
                      <option value='09'>September</option>
                      <option value='10'>October</option>
                      <option value='11'>November</option>
                      <option value='12'>December</option>
                    </select>
                  </div>
                  <div className='col-xs-8 no-padding-right'>
                    <input
                      placeholder='Year'
                      id='year'
                      type='text'
                      name='year'
                      value={p.get('year')}
                      pattern='19[0-9]{2}|2[0-9]{3}'
                      onBlur={this.setDirty(i)}
                      onChange={this.handleUserInput(i)}
                    />
                  </div>
                  <div className='col-xs-24 no-padding-left no-padding-right'>
                    <ValidationMessage
                      message='Enter a valid date of birth'
                      condition={
                        (showErrors || p.get('dirty_day') || p.get('dirty_year') || p.get('dirty_month')) &&
                        (p.get('day') < 1 || p.get('day') > 31 || p.get('month') === '' || p.get('year') < 1900 || p.get('year') > 2999)
                      }
                    />
                    <ValidationMessage
                      message='DOB does not match passenger type.'
                      condition={
                        (() => {
                          const age = moment().diff(
                            moment(
                              p.get('year') + '-' + p.get('month') + '-' + (parseInt(p.get('day'), 10) < 10 ? '0' : '') + parseInt(p.get('day'), 10)
                            ),
                            'years'
                          );
                          const classification = age < 2 ? 'INFANT' : age < 12 ? 'CHILD' : 'ADULT';
                          return classification !== p.get('ageClassification');
                        })() && showErrors
                      }
                    />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='email' value='Email: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <input
                    placeholder='Email'
                    id='email'
                    type='text'
                    name='email'
                    value={p.get('email')}
                    onBlur={this.setDirty(i)}
                    onChange={this.handleUserInput(i)}
                  />
                  <ValidationMessage
                    message='Enter a valid email address'
                    condition={(showErrors || p.get('dirty_email')) && !validateEmailAddress(p.get('email'))}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-push-2 col-sm-5'>
                  <Label name='phoneNumber' value='Phone Number: ' required='true' />
                </div>
                <div className='col-sm-push-2 col-sm-14 passenger-input'>
                  <div className='row'>
                    <div className='col-xs-6'>
                      <PhoneCodeSelect onChange={this.handleUpdatePhoneCode(i)} onBlur={this.setDirtyPhoneCode(i)} />
                    </div>
                    <div className='col-xs-18'>
                      <input
                        placeholder='Phone Number'
                        id='phonenumber'
                        type='text'
                        name='phoneNumber'
                        value={p.get('phoneNumber')}
                        onBlur={this.setDirty(i)}
                        onChange={this.handleUserInput(i)}
                      />
                    </div>
                  </div>
                  <ValidationMessage
                    message='Enter a valid phone number'
                    condition={
                      (showErrors || p.get('dirty_phoneNumber') || p.get('dirty_phoneCode')) &&
                      !validatePhoneNumber('' + p.get('phoneCode').substring(2, p.get('phoneCode').length) + p.get('phoneNumber'))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const Label = ({ name, value, required = false }) => {
  return (
    <div className='col-wrapper-va'>
      <div className='v-align'>
        <label className='label-align' htmlFor={name}>
          {required ? <span className='red'>* </span> : null}
          {value}
        </label>
      </div>
    </div>
  );
};

const ValidationMessage = ({ message, condition }) => (condition ? <div className='validation-message alert-danger'> {message} </div> : null);

PassengerEditor.propTypes = {
  // updates passenger list. ()->()
  onPassengerListUpdate: PropTypes.func.isRequired,
  // List<PassengerAsMap>
  passengers: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired,
};

export default PassengerEditor;
export const validateEmailAddress = (email) => {
  return new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  ).test(email);
};
export const validatePhoneNumber = (phoneNumber) => {
  return new RegExp(/[+]{1}[0-9]{9,}/).test(phoneNumber);
};



// WEBPACK FOOTER //
// ./src/ndc/booking/PassengerEditor.js